// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3H7A7","legacyBtn":"MutateMid_legacyBtn__2hIQn"};